import { TenantEntity } from '../TenantEntity'
import { DataSyncBase } from '@/class/model/DataSyncBase'

export class QuotationFclDetail extends DataSyncBase {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationFclDetail'
  }
  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level || 0
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get via() {
    return this._data.via
  }
  set via(via) {
    this._data.via = via
  }
  get carrier() {
    return this._data.carrier
  }
  set carrier(carrier) {
    this._data.carrier = carrier || 0
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get eq20() {
    return this._data.eq20
  }
  set eq20(eq20) {
    this._data.eq20 = eq20
  }
  get eq40() {
    return this._data.eq40
  }
  set eq40(eq40) {
    this._data.eq40 = eq40
  }
  get eqHc() {
    return this._data.eqHc
  }
  set eqHc(eqHc) {
    this._data.eqHc = eqHc
  }
  get eq45() {
    return this._data.eq45
  }
  set eq45(eq45) {
    this._data.eq45 = eq45
  }
  get term() {
    return this._data.term
  }
  set term(term) {
    this._data.term = term
  }
  get lane() {
    return this._data.lane
  }
  set lane(lane) {
    this._data.lane = lane
  }
  get departureDay() {
    return this._data.departureDay
  }
  set departureDay(departureDay) {
    this._data.departureDay = departureDay
  }
  get closingDay() {
    return this._data.closingDay
  }
  set closingDay(closingDay) {
    this._data.closingDay = closingDay
  }
  get days() {
    return this._data.days
  }
  set days(days) {
    this._data.days = days
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get serviceMode() {
    return this._data.serviceMode
  }
  set serviceMode(serviceMode) {
    this._data.serviceMode = serviceMode
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get commodity() {
    return this._data.commodity
  }
  set commodity(commodity) {
    this._data.commodity = commodity
  }
  get cost20() {
    return this._data.cost20
  }
  set cost20(cost20) {
    this._data.cost20 = cost20
  }
  get cost40() {
    return this._data.cost40
  }
  set cost40(cost40) {
    this._data.cost40 = cost40
  }
  get costHc() {
    return this._data.costHc
  }
  set costHc(costHc) {
    this._data.costHc = costHc
  }
  get cost45() {
    return this._data.cost45
  }
  set cost45(cost45) {
    this._data.cost45 = cost45
  }
  get cost20nor() {
    return this._data.cost20nor
  }
  set cost20nor(cost20nor) {
    this._data.cost20nor = cost20nor
  }
  get cost40nor() {
    return this._data.cost40nor
  }
  set cost40nor(cost40nor) {
    this._data.cost40nor = cost40nor
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get priceUuid() {
    return this._data.priceUuid
  }
  set priceUuid(priceUuid) {
    this._data.priceUuid = priceUuid
  }
  get direct() {
    return this._data.direct
  }
  set direct(direct) {
    this._data.direct = direct || true
  }
  get priceNo() {
    return this._data.priceNo
  }
  set priceNo(priceNo) {
    this._data.priceNo = priceNo
  }
  get vat() {
    return this._data.vat
  }
  set vat(vat) {
    this._data.vat = vat || 0
  }
  get dock() {
    return this._data.dock
  }
  set dock(dock) {
    this._data.dock = dock
  }
  get share() {
    return this._data.share
  }
  set share(share) {
    this._data.share = share
  }
  get saleState() {
    return this._data.saleState
  }
  set saleState(saleState) {
    this._data.saleState = saleState || 0
  }
  get sourceTenantId() {
    return this._data.sourceTenantId
  }
  set sourceTenantId(sourceTenantId) {
    this._data.sourceTenantId = sourceTenantId || 0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }

  get source() {
    return this._data.source
  }
  set source(source) {
    this._data.source = source || 0
  }

  /* =============扩展属性================= */
  get prcCreatedBy() {
    return this._data.prcCreatedBy
  }
  set prcCreatedBy(prcCreatedBy) {
    this._data.prcCreatedBy = prcCreatedBy || 0
  }
  // 整箱报价价格明细和运价
  get priceFcl() {
    return this._data.priceFcl
  }
  set priceFcl(priceFcl) {
    this._data.priceFcl = priceFcl
  }
}
